import { render } from "./WX_code.vue?vue&type=template&id=a6494c40&scoped=true"
import script from "./WX_code.vue?vue&type=script&lang=js"
export * from "./WX_code.vue?vue&type=script&lang=js"

import "./WX_code.vue?vue&type=style&index=0&id=a6494c40&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6494c40"]])

export default __exports__